/* eslint-disable no-restricted-syntax,no-useless-escape */
export const toCamelCase = (s: string) =>
  s.replace(/[_ -](.)/, (i) => i.slice(1).toUpperCase())

export const objectToCamelCase = (object: Record<string, any>) => {
  const result: Record<string, any> = {}
  for (const key in object) {
    if (object[key] instanceof Object) {
      result[toCamelCase(key)] = objectToCamelCase(object[key])
    } else {
      result[toCamelCase(key)] = object[key]
    }
  }
  return result
}

export const toSnakeCase = (s: string) =>
  s.replace(/[A-Z]/g, (i) => `_${i.toLowerCase()}`)

export const objectToSnakeCase = (object: Record<string, any>) => {
  const result: Record<string, any> = {}
  for (const key in object) {
    if (object[key] instanceof Object) {
      result[toSnakeCase(key)] = objectToSnakeCase(object[key])
    } else {
      result[toSnakeCase(key)] = object[key]
    }
  }
  return result
}

export const objectIncludeValue = <T>(value: T, obj: Record<string, T>): boolean => {
  return Object.values(obj).includes(value)
}

export function enumToArray<T extends Record<string, any>>(enumerator: T): T[keyof T][] {
  const keys = Object.keys(enumerator).filter((v) => !Number.isFinite(v))

  return keys.map((k) => enumerator[k])
}

export const isJSON = (text: string) => {
  return (/^[\],:{}\s]*$/).test(text.replace(/\\["\\\/bfnrtu]/g, '@')
    .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
    .replace(/(?:^|:|,)(?:\s*\[)+/g, ''))
}
